import { render, staticRenderFns } from "./PosList.vue?vue&type=template&id=80b389ac&scoped=true&"
import script from "./PosList.vue?vue&type=script&lang=js&"
export * from "./PosList.vue?vue&type=script&lang=js&"
import style0 from "./PosList.vue?vue&type=style&index=0&id=80b389ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b389ac",
  null
  
)

export default component.exports